/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-08 11:27:24
 * @LastEditTime: 2019-08-12 15:09:51
 * @LastEditors: Please set LastEditors
 */
import moment from 'dayjs'
import moment2 from 'moment'
import {
  getFileSize
} from '@/utils'

moment.locale('zh-cn')

export function html2Text(val: string) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function toThousandslsFilter(num: string | number) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

export function turnBr(val: { replace: (arg0: string, arg1: string) => void; }) {
  return val.replace('\n', '<br>')
}

export function Moment(date: string | number | Date | moment.Dayjs | undefined, format: string | undefined) {
  return date ? moment(date).format(format) : ''
}

export function enumsMap(code: null | undefined, objArr: { filter: (arg0: (item: any) => boolean) => any[]; }) {
  let str = ''
  if (code === undefined || code === null || !objArr) {
    // str = ''
  } else {
    let match = objArr.filter(item => {
      return item.code === code
    })[0]
    str = match ? match.description : ''
  }
  return str
}

export function Yuan(value: number | null) {
  let str = ''
  if (value === null) {
    str = '0'
  } else {
    str = '￥' + value / 100
  }
  return str
}

export function fileSize(value: number) {
  return getFileSize(value)
}

// 时间范围
export function timeRange(start: string | number | Date | moment.Dayjs | undefined, end: string | number | Date | moment.Dayjs | undefined, format: string | undefined) {
  let startStr = ''
  let endStr = ''
  let timeStr = ''
  if (start && end) {
    startStr = moment(start).format(format)
    endStr = moment(end).format(format)
    if (
      moment(start).format('YYYY-MM-DD') === moment(end).format('YYYY-MM-DD')
    ) {
      endStr = endStr.split(' ')[1]
    }
    timeStr = startStr + ' 至 ' + endStr
  }
  return timeStr
}

export function date(dates: string | number | Date | null, fmt: string) {
  if (dates === null) {
    return
  }
  let date = new Date(dates)
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }

  function padLeftZero(str: string) {
    return ('00' + str).substr(str.length)
  }

  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      // @ts-ignore

      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

export function time(date: number) {
  // @ts-ignore
  let time = parseFloat(date / 1000)
  // @ts-ignore

  let hour = parseInt(time / (60 * 60))
  // @ts-ignore

  let minute = parseInt((time - hour * 60 * 60) / 60)
  // @ts-ignore

  let second = parseInt(time - hour * 60 * 60 - minute * 60)
  let hours = hour ? hour + '小时' : ''
  let minutes = minute ? minute + '分钟' : ''
  let seconds = second ? second + '秒' : ''
  return (hours + minutes + seconds).trim()
}

// 文件大小单位转换
export function changeFileUnit(value: number) {
  if (value === 0) {
    return '0'
  } else if (value / 1024 < 1024) {
    let val = value / 1024
    return val.toFixed(2) + 'KB'
  } else if (value / 1024 / 1024 < 1024) {
    let val = value / 1024 / 1024
    return val.toFixed(2) + 'MB'
  } else {
    let val = value / 1024 / 1024 / 1024
    return val.toFixed(2) + 'GB'
  }
}

// @ts-ignore
export function ellipsis(value, length) {
  if (!value) return ''
  if (value.length > length) {
    return value.slice(0, length) + '…'
  }
  return value
}

// // 自动换行
// export function autoEnter(str) {
//   return str.replace(/(\r\n|\n|\r)/g, '\n').split('\n')
// }
export function momentDate(date:number, format:any) {
  return date ? moment2(date).format(format) : ''
}
export function ageFormat(age:any) {
  if (!age) {
    return 0
  } else {
    if (age < 12) {
      return `${age}个月`
    } else {
      let year = Math.floor(age / 12)
      let month = age % 12
      if (month === 0) {
        return `${year}岁`
      } else {
        return `${year}岁${month}个月`
      }
    }
  }
}
